import React, { Component } from 'react'
import axios from 'axios'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import 'react-notifications/lib/notifications.css'


class Addproductpage extends Component {
    constructor(props) {
        super(props)
      
        this.state = {
            name:'',
            description:'',
            brand:'',
            price:''


        }
    }

    changeHandler = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    submitHandler = e => {
        e.preventDefault()
        console.log(this.state)
        axios
            .post('https://shoppee-clone.herokuapp.com/product', this.state,
                {
                    headers: { "Content-Type": "application/json" }
                })
            .then(response => {
                console.log(response)
                window.location.replace("/products");

               

            })
            .catch(error => {
                NotificationManager.error('ERROR ADDING PRODUCT');
                        console.log(error)
                    })
    }

    render() {
        const { name, description,brand, price } = this.state
        return (



            <aside>
                <form onSubmit={this.submitHandler} autocomplete="off">
                    <div className="rounded d-flex justify-content-center" style={{ marginTop: '100px' }}>
                        <div className="col-md-4 col-sm-12 shadow-lg p-5 bg-light">
                            <h1>Add Product</h1>
                            <div className="p-4">
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control" name="name" placeholder="Product Name"  required="required"  value={name}  onChange={this.changeHandler} />
                                </div>
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control"name="description" placeholder="Description"  required="required"   value={description} onChange={this.changeHandler} />
                                </div>
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control" name="brand" placeholder="Brand"  required="required" value={brand} onChange={this.changeHandler} />
                                </div>
                                <div className='imput-group mb-3'>
                                    <input type="text" className="form-control" name="price" placeholder='Pricing' required="required" value={price} onChange={this.changeHandler} />
                                </div>
                                <div className="d-flex flex-column justify-content-center">
                                   <button type="submit" className="btn btn-primary text-center mt-2" id="continue">
                                      Confirm
                                   </button>
                                  </div>
                            </div>
                        </div>
                    </div>
                </form>
            </aside>

        )
    }
}

export default Addproductpage;